import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSync,
  faChevronCircleRight,
  faStar,
  faCrown,
  faThumbsUp,
} from '@fortawesome/free-solid-svg-icons';
import { faCommentAlt, faThumbsUp as farThumbsup } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import './app.scss';
import Vue from 'vue';
import axios from 'axios';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import VueAxios from 'vue-axios';
import VueMeta from 'vue-meta';
import VueI18n from 'vue-i18n';
import { i18n } from 'vue-lang-router';
// import VueGtag from 'vue-gtag';
import VueMatomo from 'vue-matomo';
import VueCookieBot from '@ambitiondev/vue-cookiebot-plugin';
import checkView from 'vue-check-view';
import VueClipboard from 'vue-clipboard2';
import formatUserRole from '@/mixins/formatUserRole';
import CountryFlag from 'vue-country-flag';
import checkIfMobile from './mixins/checkIfMobile';
import formatStepNumber from './mixins/formatStepNumber';
import isGeneralMaterial from './mixins/isGeneralMaterial';
import isEmptyObject from './mixins/isEmptyObject';
import isEmailValid from './mixins/isEmailValid';
import checkForHotlineTriggerPhrases from './mixins/checkForHotlineTriggerPhrases';
import isFeedSupportedForLang from './mixins/isFeedSupportedForLang';
import formatLanguageCodeForTranslation from './mixins/formatLanguageCodeForTranslation';
import router from './router';
import App from './App.vue';
import store from './store';

Vue.use(require('vue-moment'));

const VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo, {
  easing: 'ease-in-out',
  duration: 800,
});

library.add(faSync, faCommentAlt, faChevronCircleRight, faStar, faCrown, faThumbsUp, farThumbsup);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueAxios, axios);
Vue.use(VueLodash, { lodash });
Vue.use(VueMeta);
Vue.use(VueI18n);
Vue.mixin(checkIfMobile);
Vue.use(checkView);
Vue.use(VueClipboard);
Vue.component('country-flag', CountryFlag);
Vue.mixin(formatStepNumber);
Vue.mixin(formatUserRole);
Vue.mixin(isGeneralMaterial);
Vue.mixin(isEmptyObject);
Vue.mixin(checkForHotlineTriggerPhrases);
Vue.mixin(isFeedSupportedForLang);
Vue.mixin(formatLanguageCodeForTranslation);
Vue.mixin(isEmailValid);
Vue.use(VueCookieBot, {
  cookieBotID: '34fddb6b-34f2-4e17-a0ae-1d684317e25c',
});
// Vue.use(VueGtag, {
//   config: { id: 'G-KV25VMEWKM' },
// });
Vue.use(VueMatomo, {
  // Configure your matomo server and site by providing
  host: 'https://nissens.matomo.cloud',
  siteId: 10,

  // Changes the default .js and .php endpoint's filename
  // Default: 'matomo'
  trackerFileName: 'matomo',

  // Overrides the autogenerated tracker endpoint entirely
  // Default: undefined
  // trackerUrl: 'https://example.com/whatever/endpoint/you/have',

  // Overrides the autogenerated tracker script path entirely
  // Default: undefined
  // trackerScriptUrl: 'https://example.com/whatever/script/path/you/have',

  // Enables automatically registering pageviews on the router
  router,

  // Enables link tracking on regular links. Note that this won't
  // work for routing links (ie. internal Vue router links)
  // Default: true
  enableLinkTracking: true,

  // Require consent before sending tracking information to matomo
  // Default: false
  requireConsent: false,

  // Whether to track the initial page view
  // Default: true
  trackInitialView: true,

  // Run Matomo without cookies
  // Default: false
  disableCookies: false,

  // Require consent before creating matomo session cookie
  // Default: false
  requireCookieConsent: false,

  // Enable the heartbeat timer
  // (https://developer.matomo.org/guides/tracking-javascript-guide#accurately-measure-the-time-spent-on-each-page)
  // Default: false
  enableHeartBeatTimer: false,

  // Set the heartbeat timer interval
  // Default: 15
  heartBeatTimerInterval: 15,

  // Whether or not to log debug information
  // Default: false
  debug: false,

  // UserID passed to Matomo (see https://developer.matomo.org/guides/tracking-javascript-guide#user-id)
  // Default: undefined
  userId: undefined,

  // Share the tracking cookie across subdomains
  // (see https://developer.matomo.org/guides/tracking-javascript-guide#measuring-domains-andor-sub-domains)
  // Default: undefined, example '*.example.com'
  cookieDomain: undefined,

  // Tell Matomo the website domain so that clicks on these domains are not tracked as 'Outlinks'
  // Default: undefined, example: '*.example.com'
  domains: undefined,

  // A list of pre-initialization actions that run before matomo is loaded
  // Default: []
  // Example: [
  //   ['API_method_name', parameter_list],
  //   ['setCustomVariable','1','VisitorType','Member'],
  //   ['appendToTrackingUrl', 'new_visit=1'],
  //   etc.
  // ]
  preInitActions: [],

  // A function to determine whether to track an interaction as a site search
  // instead of as a page view. If not a function, all interactions will be
  // tracked as page views. Receives the new route as an argument, and
  // returns either an object of keyword, category (optional) and resultsCount
  // (optional) to track as a site search, or a falsey value to track as a page
  // view.
  // Default: false, i.e. track all interactions as page views
  // Example: (to) => {
  //   if (to.query.q && to.name === 'search') {
  //     return { keyword: to.query.q, category: to.params.category }
  //   } else {
  //    return null
  //   }
  // }
  trackSiteSearch: false,

  // Set this to include crossorigin attribute on the matomo script import
  // Default: undefined, possible values : 'anonymous', 'use-credentials'
  crossOrigin: undefined,
});

const globalData = new Vue({
  data: { $searchQuery: '', $fromApp: false, $historyCount: 0 },
});
Vue.mixin({
  computed: {
    $searchQuery: {
      get: () => globalData.$data.$searchQuery,
      set: (newPhrase) => { globalData.$data.$searchQuery = newPhrase; },
    },
    $fromApp: {
      get: () => globalData.$data.$fromApp,
      set: (newVal) => { globalData.$data.$fromApp = newVal; },
    },
    $historyCount: {
      get: () => globalData.$data.$historyCount,
      set: (newVal) => { globalData.$data.$historyCount = newVal; },
    },
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount('#app');
